/* SV GARMENT: the chosen garment, in the chosen colour, with the design on it.

   Tony, 22 Sep 2026: "when ordering different colour items the item preview
   colour needs to show that colour and also the product changes t shirt hoodie
   etc". Every tee product had one photograph, a WHITE tee, so a navy hoodie
   looked like a white t-shirt until it arrived.

   The garment photographs are the print provider's own, one per style and
   colour (tools/garment_photos.py), with the print box measured off a magenta
   test print. The design is the same transparent cut-out the press prints
   from. This lays one on the other in a canvas that sits OVER the product's
   first photograph, so the theme's gallery, zoom and thumbnails keep working
   and nothing reads pixels back (the CDN images are cross origin).

   Used by the product page (sv-garment.liquid) and by the shelf builder
   (sv-build.js), through window.SVGarment.draw(). */
(function () {
  'use strict';
  if (window.SVGarment) return; // loaded by the layout AND the product snippet

  var MAN = null, manWait = null, imgs = {};

  function manifest(url) {
    if (MAN) return Promise.resolve(MAN);
    if (!manWait) manWait = fetch(url).then(function (r) { return r.json(); })
      .then(function (j) { MAN = j; return j; });
    return manWait;
  }

  function load(src) {
    if (imgs[src]) return imgs[src];
    imgs[src] = new Promise(function (ok, bad) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { ok(i); };
      i.onerror = bad;
      i.src = src;
    });
    return imgs[src];
  }

  function luma(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length !== 6) return 0;
    var r = parseInt(h.substr(0, 2), 16), g = parseInt(h.substr(2, 2), 16), b = parseInt(h.substr(4, 2), 16);
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }

  /* The press lays a charcoal outer stroke, a white keyline and then the ink;
     a light ink inverts, or a white keyline under a white name is a blob. The
     same numbers as tools/personalise.py. */
  function nameText(ctx, text, x, y, px, ink, font) {
    var light = luma(ink) > 186;
    ctx.font = px + 'px ' + font;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.lineJoin = 'round';
    ctx.lineWidth = px * 0.1785 * 2;
    ctx.strokeStyle = light ? 'rgba(255,255,255,.85)' : '#2A2A2A';
    ctx.strokeText(text, x, y);
    ctx.lineWidth = px * 0.085 * 2;
    ctx.strokeStyle = light ? '#2A2A2A' : '#FFFFFF';
    ctx.strokeText(text, x, y);
    ctx.fillStyle = ink;
    ctx.fillText(text, x, y);
  }

  function fitText(ctx, text, maxW, maxPx, font) {
    var px = maxPx;
    ctx.font = px + 'px ' + font;
    var w = ctx.measureText(text).width;
    if (w > maxW) px = Math.max(10, Math.floor(px * maxW / w));
    return px;
  }

  /* opts: {canvas, manifest, style, colour, art, name, ink, font, slot, caps} */
  function draw(opts) {
    return manifest(opts.manifest).then(function (m) {
      var st = m.styles[opts.style] || m.styles.Tee;
      var photo = st.colours[opts.colour] || st.colours.White || st.colours[Object.keys(st.colours)[0]];
      var jobs = [load(photo)];
      if (opts.art) jobs.push(load(opts.art).catch(function () { return null; }));
      return Promise.all(jobs).then(function (got) {
        var c = opts.canvas, S = 900;
        c.width = S; c.height = S;
        var ctx = c.getContext('2d');
        ctx.clearRect(0, 0, S, S);
        ctx.drawImage(got[0], 0, 0, S, S);
        var art = got[1];
        var b = st.box, bx = b[0] * S, by = b[1] * S, bw = b[2] * S, bh = b[3] * S;
        var name = String(opts.name || '').trim();
        if (opts.caps !== false) name = name.toUpperCase();
        var font = opts.font || '"Luckiest Guy", Impact, sans-serif';
        var namePx = name ? fitText(ctx, name, bw * 0.96, Math.round(bh * 0.2), font) : 0;
        var nameH = name ? namePx * 1.25 : 0;
        var above = opts.slot === 'above';
        var artTop = by + (above ? nameH : 0);
        var artH = bh - nameH;
        if (art) {
          var r = Math.min(bw / art.width, artH / art.height);
          var w = art.width * r, h = art.height * r;
          ctx.globalAlpha = 0.97;
          ctx.drawImage(art, bx + (bw - w) / 2, artTop, w, h);
          ctx.globalAlpha = 1;
          if (name && !above) artTop += h;
        }
        if (name) {
          var ny = above ? by + namePx : Math.min(by + bh, artTop + namePx * 1.1);
          nameText(ctx, name, bx + bw / 2, ny, namePx, opts.ink || '#0E2B22', font);
        }
        c.setAttribute('data-sv-drawn', opts.style + '|' + opts.colour);
        return c;
      });
    });
  }

  window.SVGarment = { draw: draw, manifest: manifest };

  /* ---------------------------------------------------------- product page */
  function boot() {
    var cfg = document.getElementById('sv-garment-cfg');
    if (!cfg) return;
    var data;
    try { data = JSON.parse(cfg.textContent); } catch (e) { return; }
    window.SVGarment.cfg = data; // sv-multi.js reads it to write the cart preview
    var last = '';

    function checked(prefix) {
      var el = document.querySelector('variant-picker input[name^="' + prefix + '-"]:checked') ||
               document.querySelector('variant-picker select[name^="' + prefix + '-"]');
      return el ? el.value : null;
    }

    function targets() {
      // the first photograph in the slideshow, the grid and the sticky bar
      var out = [];
      var first = document.querySelector('slideshow-slide .product-media') ||
                  document.querySelector('.media-gallery__grid li:first-child .product-media');
      if (first) out.push(first);
      var grid = document.querySelector('.media-gallery__grid li:first-child .product-media');
      if (grid && grid !== first) out.push(grid);
      return out;
    }

    function overlay(host) {
      var c = host.querySelector('canvas.sv-gcv');
      if (!c) {
        c = document.createElement('canvas');
        c.className = 'sv-gcv';
        c.setAttribute('aria-hidden', 'true');
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        host.appendChild(c);
      }
      return c;
    }

    function nameNow() {
      var n = document.querySelector('.sv-perso .sv-name');
      return n ? n.value : '';
    }

    function render(force) {
      var style = checked('Style') || data.style;
      var colour = checked('Colour') || data.colour;
      var name = nameNow();
      var key = style + '|' + colour + '|' + name;
      var hosts = targets();
      if (!hosts.length) return;
      if (!force && key === last && hosts.every(function (h) { return h.querySelector('canvas.sv-gcv'); })) return;
      last = key;
      hosts.forEach(function (h) {
        draw({ canvas: overlay(h), manifest: data.manifest, style: style, colour: colour,
               art: data.art, name: name, ink: data.ink, font: data.font, slot: data.slot,
               caps: data.caps }).catch(function () {});
      });
      var cap = document.querySelector('.sv-gcap');
      if (cap) cap.textContent = 'Shown: ' + style + ' in ' + colour + '. Screens show colour differently; see the note below.';
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(function () { render(true); }, 60);
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sv-name')) render(false);
    });
    // Horizon re-renders the product section over the network when the
    // variant changes, which throws the overlay away. Put it back.
    new MutationObserver(function () { render(false); })
      .observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    render(true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { render(true); });
  }


  /* ------------------------------------------------------------- cart
     Tony: "ensure the garment image changes with colour so they see exactly
     what they are ordering and it should save in the cart with that image and
     all details visible". The cart line's own image is the product's first
     photograph, a WHITE tee reading YOUR NAME, whatever was ordered. Every
     personalised garment line now carries a hidden _sv_preview property (the
     leading underscore keeps it off the cart, the checkout and the packing
     slip) holding exactly what the preview drew: style, colour, artwork,
     name, ink and lettering. Here it is drawn again over each cart row's
     thumbnail, on the cart page and in the drawer, by the same draw(). */
  var cartBusy = false, cartAgain = false;
  function cartPreviews() {
    var rows = document.querySelectorAll('[data-key]');
    var need = Array.prototype.filter.call(rows, function (r) {
      return r.querySelector('img') && !r.querySelector('canvas.sv-cart-gcv');
    });
    if (!need.length) return;
    if (cartBusy) { cartAgain = true; return; }
    cartBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var by = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties && it.properties._sv_preview;
          if (!p) return;
          try { by[it.key] = JSON.parse(p); } catch (e) {}
        });
        need.forEach(function (row) {
          var o = by[row.getAttribute('data-key')];
          if (!o || !o.m) return;
          var img = row.querySelector('img');
          if (!img || row.querySelector('canvas.sv-cart-gcv')) return;
          var c = document.createElement('canvas');
          c.className = 'sv-cart-gcv';
          c.setAttribute('role', 'img');
          c.setAttribute('aria-label', (o.s || '') + ' in ' + (o.c || '') + (o.n ? ', printed ' + o.n : ''));
          c.style.cssText = 'display:block;width:100%;height:auto;aspect-ratio:1/1;border-radius:inherit';
          draw({ canvas: c, manifest: o.m, style: o.s, colour: o.c, art: o.a, name: o.n,
                 ink: o.i, font: o.f, caps: o.k, slot: o.l })
            .then(function () {
              if (row.querySelector('canvas.sv-cart-gcv')) return;
              img.style.display = 'none';
              img.parentNode.insertBefore(c, img);
            }).catch(function () {});
        });
      }).catch(function () {})
      .then(function () {
        cartBusy = false;
        if (cartAgain) { cartAgain = false; setTimeout(cartPreviews, 50); }
      });
  }
  var cartT = null;
  function cartSoon() { clearTimeout(cartT); cartT = setTimeout(cartPreviews, 250); }
  function cartBoot() {
    cartSoon();
    new MutationObserver(cartSoon).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:cart:lines-update', cartSoon);
    document.addEventListener('cart:refresh', cartSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
      Array.prototype.forEach.call(document.querySelectorAll('canvas.sv-cart-gcv'), function (c) {
        var img = c.nextElementSibling; if (img && img.tagName === 'IMG') img.style.display = '';
        c.remove();
      });
      cartSoon();
    });
  }

  function start() { boot(); cartBoot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
